export const validateMissingPassword = (password) => {
  return password ?? !!password;
};

export const checkPasswordStrength = (password) => {
  const regEx = /^(?=.*[0-9].*[0-9]).{8,24}$/i;
  return regEx.test(password);
};

export function getPasswordLengthError(password) {
  if (!checkPasswordStrength(password)) {
    return {
      'en-US': 'Password must be between 8 to 24 characters long containing at least two numeric characters',
      'fr-CA': 'Le mot de passe doit comporter entre 8 et 24 caractères, dont au moins deux caractères numériques.'
    };
  }
  return null;
}
